import { AssessmentSurveyCategory } from './assessmentSurvey'
import { OnLoadAction } from './action'
import { BUTTON_ACTION_TYPE, ButtonAction } from './components'
import { AVAILABLE_SERVICE, CONSULTATION_TYPE, OTHER_SERVICE, PRESCRIPTION_INTEGRATION } from './consultation'
import { IndicationCategory, Pharmacy } from './indication'
import { Modal } from './modal'
import { StepConditionalRoute } from './route'
import { BACK_TYPE, Step } from './step'

export enum MODULE_TYPE {
  DEFAULT = 'default',
  CONSULTATION = 'consultation',
  CONSULTATION_LANDING = 'consultationLanding',
  PHARMACY_SELECTOR = 'pharmacySelector',
  INDICATION_CATEGORIES = 'indicationCategories',
  INDICATION_SURVEY = 'indicationSurvey',
  FULFILLMENT_CHOICE_SELECTION = 'fulfillmentChoiceSelection',
  ASSESSMENT_SURVEY_CATEGORIES = 'assessmentSurveyCategories'
}

export type DefaultModule = {
  type: MODULE_TYPE.DEFAULT
  modals?: Record<string, Modal> // Modals of the module
}

type Steps = Record<string, Step>

// TODO: Remove this module type?
export type ConsultationModule = {
  type: MODULE_TYPE.CONSULTATION
  consultationType: CONSULTATION_TYPE
  backButton?: BACK_TYPE // Default is no back button
}

export type ConsultationLandingModule = {
  type: MODULE_TYPE.CONSULTATION_LANDING
  consultationType: AVAILABLE_SERVICE
  buttonAction: ButtonAction<BUTTON_ACTION_TYPE.FINISH_CONSULTATION_FORM | BUTTON_ACTION_TYPE.NEXT_MODULE | BUTTON_ACTION_TYPE.NEXT_STEP>
  steps?: Steps // Form steps of the module
}

export type IndicationSurveyModule = {
  type: MODULE_TYPE.INDICATION_SURVEY
  consultationType: CONSULTATION_TYPE
}

export type PharmacySelectorModule = {
  type: MODULE_TYPE.PHARMACY_SELECTOR
  pharmacies: Pharmacy[]
  backButton?: BACK_TYPE // Default is no back button
  buttonAction: ButtonAction<BUTTON_ACTION_TYPE.NEXT_MODULE>
  integration?: PRESCRIPTION_INTEGRATION
}

export type IndicationCategoriesModule = {
  type: MODULE_TYPE.INDICATION_CATEGORIES
  consultationType: CONSULTATION_TYPE.PRESCRIPTION | CONSULTATION_TYPE.MENTAL
  indicationCategories: IndicationCategory[]
  backButton?: BACK_TYPE // Default is no back button
}

export type AssessmentCategoriesModule = {
  type: MODULE_TYPE.ASSESSMENT_SURVEY_CATEGORIES
  consultationType: CONSULTATION_TYPE.MENTAL
  assessmentSurveyCategories: AssessmentSurveyCategory[]
  backButton?: BACK_TYPE
}

export type Module = {
  id: string
  name: string

  onLoadActions?: OnLoadAction[] // Actions to be executed when the module is loaded
} & (
  | ({
      steps: Steps // Steps of the module
      initialSteps: StepConditionalRoute[] // Initial step to be shown
    } & (DefaultModule | ConsultationModule | IndicationSurveyModule))
  | PharmacySelectorModule
  | IndicationCategoriesModule
  | ConsultationLandingModule
  | AssessmentCategoriesModule
)
